import React from 'react';
import { observer } from 'mobx-react';
import { Form } from 'react-bootstrap';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FieldInput = observer(({ field, ...other }: any): JSX.Element => <Form.Control {...field.bind(other)} />);
